import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
/**
 * 颜色选择器组件，继承Base
 * @module $ui/components/my-color-picker
 */

import { ColorPicker } from 'element-ui';
import Base from '../Base';
export default {
  name: 'MyColorPicker',
  mixins: [Base],
  components: {
    ColorPicker: ColorPicker
  },
  props: {
    value: String
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h(ColorPicker, {
      "ref": 'comp',
      "class": 'my-color-picker',
      "props": _objectSpread({}, this.innerProps),
      "on": _objectSpread({}, this.$listeners),
      "attrs": _objectSpread({}, this.innerProps),
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    });
    return this.renderComponent(vnode);
  }
};